import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialOneDriveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialOneDrive",
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.6 6c-2.69 0-4.98 1.67-5.93 4.01-.84-.51-1.82-.81-2.87-.81-3.09 0-5.6 2.51-5.6 5.6 0 .3.04.59.09.87C1.43 16.01 0 17.64 0 19.6c0 2.2 1.8 4 4 4h2.36c-.32-.74-.49-1.55-.49-2.4 0-2.97 2.12-5.45 4.92-6.01a7.97 7.97 0 0 1 7.36-4.92c1.86 0 3.62.65 5.04 1.82.25-.07.5-.12.76-.16C23.7 8.62 20.97 6 17.6 6m.55 6.4c-2.87 0-5.25 2.07-5.74 4.8H12c-2.2 0-4 1.8-4 4s1.8 4 4 4h16.8c1.76 0 3.2-1.44 3.2-3.2s-1.44-3.2-3.2-3.2h-.08A3.999 3.999 0 0 0 24.8 14c-.77 0-1.49.23-2.1.61-1.07-1.34-2.7-2.21-4.55-2.21"
    })
  }));
};
SocialOneDriveIcon.displayName = 'SocialOneDriveIcon';